export enum EStoreType {
	CouchDb = "couchdb",
	PouchDb = "pouchdb",
}